// Usage source → label, colour (tool palette), icon, usage method (mockup data.js SOURCE_INFO).
// CLI tool = fill + terminal icon, API key call = hatching of the same colour + key icon (plan 8.1.2).
import type { Source } from '@aiax-hub/contracts';
import { TOOL_COLOR } from '@aiax-hub/ui-tokens';
import type { IconName } from './icon-paths';

export interface SourceInfo {
  key: string;
  /** usage method: cli | api | other */
  path: 'cli' | 'api' | 'other';
  tool: string;
  /** support-table tool id (value badges link to its cells) */
  supportTool: string | null;
  provider: 'anthropic' | 'openai' | 'other';
  color: string;
  hatched: boolean;
  icon: IconName;
  label: string;
  /** glossary slug */
  term?: string;
  order: number;
}

const INFO: Record<Source, SourceInfo> = {
  'cli.claude_code': { key: 'cli.claude_code', path: 'cli', tool: 'claude_code', supportTool: 'claude_code', provider: 'anthropic', color: TOOL_COLOR['cli.claude_code'], hatched: false, icon: 'terminal', label: 'Claude Code', term: 'claude-code', order: 0 },
  'cli.codex': { key: 'cli.codex', path: 'cli', tool: 'codex', supportTool: 'codex', provider: 'openai', color: TOOL_COLOR['cli.codex'], hatched: false, icon: 'terminal', label: 'Codex', term: 'codex-cli', order: 1 },
  'api.anthropic': { key: 'api.anthropic', path: 'api', tool: 'anthropic', supportTool: 'anthropic_api', provider: 'anthropic', color: TOOL_COLOR['api.anthropic'], hatched: true, icon: 'key', label: 'Anthropic API', term: 'api-key', order: 2 },
  'api.openai': { key: 'api.openai', path: 'api', tool: 'openai', supportTool: 'openai_api', provider: 'openai', color: TOOL_COLOR['api.openai'], hatched: true, icon: 'key', label: 'OpenAI API', term: 'api-key', order: 3 },
};

export function sourceInfo(src: string): SourceInfo {
  return (
    INFO[src as Source] ?? { key: src, path: 'other', tool: 'other', supportTool: null, provider: 'other', color: TOOL_COLOR.other, hatched: false, icon: 'dot', label: src, order: 9 }
  );
}
